import script from "./ColumnLeftSide.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnLeftSide.vue?vue&type=script&setup=true&lang=js"

import "./ColumnLeftSide.vue?vue&type=style&index=0&id=5524232c&lang=scss"

const __exports__ = script;

export default __exports__